<section class="organization-dialog">
  <header class="dialog-header">
    <h1 class="company-title">{{organization?.Company?.Name}}</h1>

    <mat-menu #appMenu="matMenu">
      <button mat-menu-item type="button" (click)="createUser()"><mat-icon>person_add</mat-icon>Ny administratör</button>
      <button mat-menu-item type="button" (click)="createSalaryReciever()"><mat-icon>person_add</mat-icon>Ny medarbetare</button>
    </mat-menu>
    <div class="header-actions">
      <button *ngIf="isMasterAccount || isAdmin"
              mat-flat-button
              color="accent"
              type="button"
              class="edit-company-action"
              (click)="editCompany(organization)">
        Redigera företagsuppgifter
      </button>
      <button mat-icon-button type="button" class="dialog-actions" [matMenuTriggerFor]="appMenu"
              aria-label="Fler alternativ"><mat-icon>more_vert</mat-icon></button>
    </div>
  </header>

  <mat-tab-group (selectedTabChange)="onTabChange($event)" class="custom-tab-group">
    <mat-tab label="Administratörer ({{customerData?.length || 0}})">
      <div class="tab-content">
        <div class="filter-bar">
          <label class="search-field">
            <span>Sök administratör</span>
            <span class="search-box">
              <mat-icon>search</mat-icon>
              <input type="search" (input)="applyFilter($event.target.value)" aria-label="Sök administratör">
            </span>
          </label>
        </div>

        <div class="table-shell">
          <div class="table-scroll">
            <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                       matSortActive="name" matSortDirection="asc" matSortDisableClear>
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Namn</mat-header-cell>
                <mat-cell *matCellDef="let row" (click)="editUser(row)" class="clickable-cell">
                  <strong>{{row?.FirstName + ' ' + row?.LastName | truncate:25}}</strong>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="roles">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>Roller</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>
                  <span *ngIf="row.OrganizationMasterAccount">Master, {{ getRolesAsString(row?.Roles) }}</span>
                  <span *ngIf="!row.OrganizationMasterAccount">{{ getRolesAsString(row?.Roles) }}</span>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="personalNumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>Personnummer</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>{{row?.PersonalNumber}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>E-postadress</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>{{row?.Email}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="created">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>Medlem sedan</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>
                  {{(row?.Created == '0001-01-01T00:00:00' ? '' : row?.Created) | swedishDate: 'yyyy-MM-dd'}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="lastLogin">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>Senast inloggad</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>
                  {{(row?.LastLogin == '2017-01-01T00:00:00' ? '' : row?.LastLogin) | swedishDate: 'yyyy-MM-dd'}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="suspended">
                <mat-header-cell *matHeaderCellDef>Spärrat</mat-header-cell>
                <mat-cell *matCellDef="let row"><mat-icon *ngIf="row?.Suspended" aria-label="Spärrad">lock</mat-icon></mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
            <div *ngIf="customerData && customerData.length === 0" class="empty-state">Inga administratörer hittades.</div>
          </div>
        </div>

        <section class="role-description" aria-labelledby="role-description-title">
          <h2 id="role-description-title">Rollbeskrivning</h2>
          <p><strong>Master:</strong> Samma som nedan och dessutom redigera företagets uppgifter samt radera andra administratörers utkast.</p>
          <p><strong>Companyadmin:</strong> Har rättighet att skapa och redigera fakturor, lägga till kunder och lägga till nya administratörer.</p>
        </section>
      </div>
    </mat-tab>

    <mat-tab label="Medarbetare ({{paymentRecievers?.length || 0}})">
      <div class="tab-content">
        <div class="filter-bar">
          <label class="search-field">
            <span>Sök medarbetare</span>
            <span class="search-box">
              <mat-icon>search</mat-icon>
              <input type="search" (input)="applyFilter2($event.target.value)" aria-label="Sök medarbetare">
            </span>
          </label>
        </div>

        <div class="table-shell">
          <div class="table-scroll">
            <mat-table [dataSource]="dataSource2" matSort (matSortChange)="sortData2($event)"
                       matSortActive="name" matSortDirection="asc" matSortDisableClear>
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Namn</mat-header-cell>
                <mat-cell *matCellDef="let row" (click)="editPaymentReciever(row)" class="clickable-cell">
                  <strong>{{row?.LastName + ', ' + row?.FirstName | truncate:30}}</strong>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="personalNumber">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Personnummer</mat-header-cell>
                <mat-cell *matCellDef="let row">{{row?.PersonalNumber}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxShow="false" fxShow.gt-sm>E-postadress</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm>{{row?.Email | truncate:30}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="edit">
                <mat-header-cell *matHeaderCellDef fxShow="false" fxShow.gt-sm>Åtgärder</mat-header-cell>
                <mat-cell *matCellDef="let row" fxShow="false" fxShow.gt-sm class="row-actions">
                  <button mat-icon-button type="button" (click)="editPaymentReciever(row)"
                          aria-label="Redigera medarbetare" matTooltip="Redigera">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button type="button" class="delete-action" (click)="deletePaymentReciever(row)"
                          aria-label="Radera medarbetare" matTooltip="Radera">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns2"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns2;"></mat-row>
            </mat-table>
            <div *ngIf="paymentRecievers && paymentRecievers.length === 0" class="empty-state">Inga medarbetare hittades.</div>
          </div>
          <mat-paginator #paginator2 [pageSizeOptions]="[5,10,25,100]"></mat-paginator>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</section>
